import React from 'react';

export const SendIcon: React.FC = () => (
	<svg width='2.1rem' height='2.2rem' viewBox='0 0 21 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M9.40234 11.6973L19.6695 1.43018M19.6695 1.43018H12.6292M19.6695 1.43018V8.47049' stroke='currentColor' strokeWidth='1.5' />
		<path d='M19.7376 11.7641V21.0001H1.26562V1.50195H9.47538' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
